import type { DaySchedule } from "@/domain/prayer/types";

import { parseHHmmInIst } from "./time";

/**
 * On a Friday schedule, replace the Dhuhr slot's Azaan/Jama'ah times with the
 * Jummah-specific times configured by the masjid. Returns the schedule
 * unchanged on non-Fridays or when either input time is missing/malformed.
 *
 * The Dhuhr label is already "Jumu'ah" coming out of the prayer engine on
 * Fridays — we only swap the times here.
 */
export function applyJummahForFriday(
  schedule: DaySchedule,
  jummahAzaan: string,
  jummahJamaah: string,
): DaySchedule {
  if (!schedule.isFriday) return schedule;
  const azaan = parseHHmmInIst(jummahAzaan, schedule.date);
  const jamaah = parseHHmmInIst(jummahJamaah, schedule.date);
  if (!azaan || !jamaah) return schedule;
  return {
    ...schedule,
    prayers: schedule.prayers.map((p) =>
      p.name === "dhuhr"
        ? { ...p, label: "Jumu'ah", azaanTime: azaan, jamaahTime: jamaah }
        : p,
    ),
  };
}
